// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AlM1A","content":"styles_content__2PD-7","tableWrap":"styles_tableWrap__a1AfD"};